import { HttpClient } from '@angular/common/http';
import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { of } from 'rxjs';
import { catchError } from 'rxjs/internal/operators/catchError';
import { ContractsService } from 'src/app/services/contracts.service';

@Component({
  selector: 'aw-box-interface-info-dialog',
  templateUrl: './box-interface-info-dialog.component.html',
  styleUrls: ['./box-interface-info-dialog.component.scss']
})
export class BoxInterfaceInfoDialogComponent implements OnInit {

  box = null;
  contract = null;
  dataSource = null;
  loading: boolean = true;
  errorMessage: string | null = null;

  constructor(
    public dialogRef: MatDialogRef<BoxInterfaceInfoDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private http: HttpClient,
    private ContractsService: ContractsService
  ) {}

  ngOnInit(): void {
    this.contract = this.data.contract;
    this.box = this.data.box;
    // this.http.get<any>('http://localhost:3000/getWeSethInterface').subscribe(response => {
    //   this.dataSource = response.iface_list;
    //   console.log(response);
    // });
    
    this.ContractsService.getWesethIfaces(this.contract, this.box.id)
    .pipe(
      catchError(error => {
        console.error('Error occurred:', error);
        this.loading = false;
        this.errorMessage = 'An error occurred while fetching the box interfaces. Please try again later.';
        return of({});
    })
    ).subscribe(response => {
      this.loading = false;
      this.dataSource = response.data.iface_list;
    });
  }

}
